/**
 * Должно совпадать с backend/utils/therapistBookableSlots.js (сетка 50 + перерыв 10).
 */
export const BOOKING_SLOT_MINUTES = 50;
export const SLOT_GAP_MINUTES = 10; // перерыв между слотами для клиента
const STEP_MINUTES = BOOKING_SLOT_MINUTES + SLOT_GAP_MINUTES;

export function parseTimeToMinutes(t) {
    if (t == null || t === '') return NaN;
    const parts = String(t).trim().split(':').map((x) => parseInt(x, 10));
    const h = parts[0] ?? 0;
    const m = parts[1] ?? 0;
    const s = parts[2] ?? 0;
    return h * 60 + m + s / 60;
}

function minutesToPgTime(totalMinutes) {
    const m = Math.floor(totalMinutes);
    const h = Math.floor(m / 60) % 24;
    const min = m % 60;
    return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}:00`;
}

export function expandWindowToBookableTimes(startTime, endTime) {
    const startM = Math.round(parseTimeToMinutes(startTime));
    const endM = Math.round(parseTimeToMinutes(endTime));
    if (!Number.isFinite(startM) || !Number.isFinite(endM) || endM <= startM) return [];

    const out = [];
    let cur = startM;
    while (cur + BOOKING_SLOT_MINUTES <= endM) {
        out.push({
            start_time: minutesToPgTime(cur),
            end_time: minutesToPgTime(cur + BOOKING_SLOT_MINUTES),
        });
        cur += STEP_MINUTES;
    }
    return out;
}

export function getWindowDurationMinutes(startTime, endTime) {
    const a = Math.round(parseTimeToMinutes(startTime));
    const b = Math.round(parseTimeToMinutes(endTime));
    if (!Number.isFinite(a) || !Number.isFinite(b)) return NaN;
    return b - a;
}

export function timeIntervalsOverlap(aStart, aEnd, bStart, bEnd) {
    const as = Math.round(parseTimeToMinutes(aStart));
    const ae = Math.round(parseTimeToMinutes(aEnd));
    const bs = Math.round(parseTimeToMinutes(bStart));
    const be = Math.round(parseTimeToMinutes(bEnd));
    if ([as, ae, bs, be].some((x) => !Number.isFinite(x))) return false;
    return as < be && ae > bs;
}
